export const findDifference = <T>(before: T[], after: T[]): [added: T[], removed: T[]] => {
  const beforeSet = new Set(before);
  const afterSet = new Set(after);
  return [
    after.filter((item) => !beforeSet.has(item)),
    before.filter((item) => !afterSet.has(item)),
  ];
};

export const areEqualIgnoreOrder = <T>(before: T[], after: T[]): boolean => {
  const beforeSet = new Set(before);
  const afterSet = new Set(after);
  return !(
    after.some((item) => !beforeSet.has(item)) || before.some((item) => !afterSet.has(item))
  );
};
